import { render, staticRenderFns } from "./AyandeBankAccountsAccessModal.vue?vue&type=template&id=1bf448a6&scoped=true"
import script from "./AyandeBankAccountsAccessModal.vue?vue&type=script&lang=js"
export * from "./AyandeBankAccountsAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf448a6",
  null
  
)

export default component.exports